export class Provlookup {
  public hpcodes: string;
  public type: string;
  public search: string;
  public name: string;
  public building: string;
  public street: string;
  public suburb: string;
  public city: string;
  public province: string;
  public phone: string;
  public provid: string;
  public spec: string;
  public page: number = 0;
  public typeGp: string;
  public fromDate: string;
}
